import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { useT } from "@/lib/i18n/use-t";
import { T } from "./historical-return-form.i18n";
import type { ComponentFormProps } from "./types";

export type HistoricalReturnConfig = {
  title?: string;
  description?: string;
};

type HistoricalReturnFormProps = ComponentFormProps<HistoricalReturnConfig>;

export function HistoricalReturnForm({ config, onChange }: HistoricalReturnFormProps) {
  const t = useT(T);

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="historical-return-title">{t.title}</Label>
        <Input
          id="historical-return-title"
          value={config.title || ""}
          onChange={(e) => onChange({ ...config, title: e.target.value })}
          placeholder={t.titlePlaceholder}
        />
        <p className="text-xs text-muted-foreground">{t.titleHelp}</p>
      </div>

      <div className="space-y-2">
        <Label htmlFor="historical-return-description">{t.description}</Label>
        <Textarea
          id="historical-return-description"
          value={config.description || ""}
          onChange={(e) => onChange({ ...config, description: e.target.value })}
          placeholder={t.descriptionPlaceholder}
          rows={2}
        />
        <p className="text-xs text-muted-foreground">{t.descriptionHelp}</p>
      </div>

      <div className="p-3 bg-muted/50 rounded-md">
        <p className="text-xs text-muted-foreground">{t.componentDescription}</p>
      </div>
    </div>
  );
}

export function getDefaultHistoricalReturnConfig(): HistoricalReturnConfig {
  return {
    title: "Historical Return",
    description: "Indexed historical return of the portfolio over time.",
  };
}
